import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";

interface CompletionActionsProps {
  onNextAssessment: () => void;
  onViewDashboard: () => void;
  /** True when all assessments are finished — hides the Next button */
  allComplete?: boolean;
}

/**
 * Shared two-button CTA rendered at the bottom of every assessment
 * completion screen.
 *
 *   [ Next Assessment → ]   (primary – purple)
 *   [ View Dashboard ]      (ghost – secondary)
 */
export function CompletionActions({
  onNextAssessment,
  onViewDashboard,
  allComplete = false,
}: CompletionActionsProps) {
  return (
    <div className="flex gap-4 justify-center">
      {!allComplete && (
        <Button
          size="sm"
          onClick={onNextAssessment}
          className="bg-primary hover:bg-primary/90 text-primary-foreground px-4 py-2 h-auto text-sm"
        >
          Next Assessment
          <ArrowRight className="ml-1.5 h-4 w-4" />
        </Button>
      )}
      <Button
        size="sm"
        onClick={onViewDashboard}
        className="bg-accent hover:bg-accent-light text-white px-4 py-2 h-auto text-sm"
      >
        View Dashboard
      </Button>
    </div>
  );
}
